import {
  type AppController,
  type SerializedPageStructure,
} from '@wix/document-services-types'

import {
  assertAppControllerData,
  assertDataBindingController,
  assertNonNullable,
  modifyComponentByVeloId,
} from './utils'
import { ROUTER_DATASET_VELO_ID } from './veloIds'

export const renameRouterDataset = ({
  page,
  name,
}: {
  page: SerializedPageStructure
  name: string
}): SerializedPageStructure =>
  modifyComponentByVeloId({
    root: page,
    veloId: ROUTER_DATASET_VELO_ID,
    modifyComponent: routerDataset => {
      assertDataBindingController(routerDataset)
      assertNonNullable(routerDataset.data)
      assertAppControllerData(routerDataset.data)
      const data: AppController = { ...routerDataset.data, name }
      return { ...routerDataset, data }
    },
  })
